<template>
    <div
        class="home-modules-page"
        :class="{ 'default-home': userRole != ROLE_ADMIN.value && userRole != ROLE_COURIER.value }"
        :style="themePageStyle">
        <template v-if="userRole === ROLE_ADMIN.value">
            <HomeAdmin />
        </template>
        <template v-else-if="userRole === ROLE_COURIER.value">
            <HomeCourier />
        </template>
        <template v-else>
            <div class="home-modules-header">
                <div>
                    <span class="home-modules-kicker">{{ themeBrandName }}</span>
                    <h1 data-test-id="title-default_home">{{ $tl("labels.services") }}</h1>
                    <p>Accédez rapidement à vos modules {{ themeBrandName }} et pilotez vos services depuis un espace centralisé.</p>
                </div>
            </div>
            <modules-list />
        </template>
    </div>
</template>

<script>
import ModulesList from "../components/Modules/ModulesList.vue";
import HomeAdmin from "./Admin/Home.vue";
import HomeCourier from "./Courier/Home.vue";
import RolesEnum from "../mixins/enums/RolesEnum";

export default {
    name: "Home",
    computed: {
        userRole() {
            return this.$store.getters["users/role"];
        },
        themePageStyle() {
            return {
                "--theme-main-color": this.$style["main-color"] || "#083e60",
                "--theme-main-color-rgb": this.$style["main-color-rgb"] || "8, 62, 96",
                "--theme-main-color-light": this.$style["main-color-light"] || "#30a4b7",
                "--theme-default-page-background":
                    this.$style["default-page-background"] || "linear-gradient(180deg, #ffffff 0%, #f6fbfe 44%, #edf6fb 100%)",
            };
        },
    },
    mixins: [RolesEnum],
    components: {
        ModulesList,
        HomeAdmin,
        HomeCourier,
    },
};
</script>

<style lang="scss" scoped>
.home-modules-page {
    position: relative;
    width: 100%;
    --theme-main-color: #083e60;
    --theme-main-color-rgb: 8, 62, 96;
    --theme-main-color-light: #30a4b7;
    --theme-default-page-background: linear-gradient(180deg, #ffffff 0%, #f6fbfe 44%, #edf6fb 100%);
}

.home-modules-page.default-home {
    max-width: 1180px;
    padding: 34px 24px 46px;
}

.home-modules-page.default-home::before {
    position: fixed;
    inset: 60px 0 0;
    z-index: -1;
    pointer-events: none;
    content: "";
    background: var(--theme-default-page-background);
}

.home-modules-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 24px;
    margin-bottom: 24px;
}

.home-modules-kicker {
    display: block;
    margin-bottom: 5px;
    color: var(--theme-main-color-light);
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.08em;
    line-height: 1.2;
    text-transform: uppercase;
}

h1 {
    margin: 0;
    color: #17202a;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.15;
}

.home-modules-header p {
    max-width: 620px;
    margin: 8px 0 0;
    color: #667085;
    font-size: 14px;
    line-height: 1.55;
}

.home-modules-badge {
    display: inline-flex;
    align-items: center;
    min-height: 30px;
    padding: 0 12px;
    color: var(--theme-main-color);
    font-size: 12px;
    font-weight: 800;
    white-space: nowrap;
    background: rgba(var(--theme-main-color-rgb), 0.08);
    border: 1px solid rgba(var(--theme-main-color-rgb), 0.1);
    border-radius: 999px;
}

@media (max-width: 767px) {
    .home-modules-page.default-home {
        padding: 24px 14px 34px;
    }

    .home-modules-header {
        align-items: flex-start;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 18px;
    }

    h1 {
        font-size: 24px;
    }
}
</style>
